import React from 'react';
import { useLocation } from 'react-router-dom';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import {
  CART_PATHS,
  getCartBookingCount,
  type CartType,
  useCart,
} from '../../cart/cart';

const CART_NAMES: Record<CartType, string> = {
  seminar_376: 'Seminare',
  muenchenprogramm: 'Münchenprogramm',
};

const CartIndicatorContent = ({ itemCount }: { itemCount: number }) => (
  <>
    <span className="cart-indicator-label">Warenkorb</span>
    <span aria-hidden="true" className="cart-indicator-count">
      {itemCount}
    </span>
  </>
);

const CartLink = ({
  cartType,
  itemCount,
  pathname,
}: {
  cartType: CartType;
  itemCount: number;
  pathname: string;
}) => {
  const cartPath = CART_PATHS[cartType];
  const bookingLabel = itemCount === 1 ? 'Buchung' : 'Buchungen';

  return (
    <UniversalLink
      aria-current={pathname === cartPath ? 'page' : undefined}
      aria-label={`${CART_NAMES[cartType]}: ${itemCount} ${bookingLabel} im Warenkorb`}
      className="cart-indicator"
      href={cartPath}
    >
      <CartIndicatorContent itemCount={itemCount} />
    </UniversalLink>
  );
};

const CartIndicator = () => {
  const seminarCart = useCart('seminar_376');
  const muenchenprogrammCart = useCart('muenchenprogramm');
  const { pathname } = useLocation();
  const carts = [
    {
      cartType: 'seminar_376' as const,
      itemCount: getCartBookingCount(seminarCart),
    },
    {
      cartType: 'muenchenprogramm' as const,
      itemCount: getCartBookingCount(muenchenprogrammCart),
    },
  ];
  const filledCarts = carts.filter(({ itemCount }) => itemCount > 0);

  if (filledCarts.length === 0) {
    return (
      <span
        aria-disabled="true"
        aria-label="Keine Buchungen im Warenkorb"
        className="cart-indicator is-disabled"
      >
        <CartIndicatorContent itemCount={0} />
      </span>
    );
  }

  return (
    <>
      {filledCarts.map(({ cartType, itemCount }) => (
        <CartLink
          cartType={cartType}
          itemCount={itemCount}
          key={cartType}
          pathname={pathname}
        />
      ))}
    </>
  );
};

export default CartIndicator;
